import { apiClient } from '@/api/client';

import {
  DocumentListResponse,
  DocumentDetail,
  DocumentListParams,
  SimilarDocument,
  SimilarDocumentsParams
} from './types';

/**
 * Fetches paginated list of documents (metadata only, no sections)
 */
export async function fetchDocuments(
  params?: DocumentListParams
): Promise<DocumentListResponse> {
  const queryParams = new URLSearchParams();

  if (params?.skip !== undefined) {
    queryParams.append('skip', params.skip.toString());
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  const queryString = queryParams.toString();
  const endpoint = `/documents/${queryString ? `?${queryString}` : ''}`;

  return apiClient<DocumentListResponse>(endpoint, {
    method: 'GET'
  });
}

/**
 * Fetches a single document with full details and sections
 */
export async function fetchDocumentByUrl(
  sourceUrl: string
): Promise<DocumentDetail> {
  const encodedUrl = encodeURIComponent(sourceUrl);
  return apiClient<DocumentDetail>(`/documents/${encodedUrl}`, {
    method: 'GET'
  });
}

/**
 * Fetches similar documents based on description embedding
 */
export async function fetchSimilarDocuments(
  documentId: string,
  params?: SimilarDocumentsParams
): Promise<SimilarDocument[]> {
  const queryParams = new URLSearchParams();
  if (params?.top_k !== undefined) {
    queryParams.append('top_k', params.top_k.toString());
  }
  if (params?.threshold !== undefined) {
    queryParams.append('threshold', params.threshold.toString());
  }

  const encodedId = encodeURIComponent(documentId);
  const queryString = queryParams.toString();
  const endpoint = `/documents/similar/${encodedId}${queryString ? `?${queryString}` : ''}`;

  return apiClient(endpoint, {
    method: 'GET'
  });
}
